import { render, staticRenderFns } from "./SignUpDuplicated.vue?vue&type=template&id=1cacc04f"
import script from "./SignUpDuplicated.vue?vue&type=script&lang=js"
export * from "./SignUpDuplicated.vue?vue&type=script&lang=js"
import style0 from "./SignUpDuplicated.vue?vue&type=style&index=0&id=1cacc04f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports